module.exports = __webpack_public_path__ + "img/vespa_15.17331ba0.png";